import { Text } from '@chakra-ui/react';

import { DocumentUploadsPanel } from '#pages/document/files/document-uploads-panel';

export function DocumentFilesBlock({
  documentId,
  apiHost,
  userEmail,
  documentPath,
}: {
  documentId: string | undefined;
  apiHost: string;
  userEmail: string;
  /** Canonical document path for links to `/d/files/{path}`. */
  documentPath: string;
}) {
  if (!documentId) {
    return (
      <Text color="fg.muted" fontSize="sm">
        Save the document to list uploads linked to it.
      </Text>
    );
  }

  return (
    <DocumentUploadsPanel
      variant="embedded"
      documentId={documentId}
      apiHost={apiHost}
      userEmail={userEmail}
      documentPath={documentPath}
    />
  );
}
